import React from "react";
import { BrainIcon, CalendarHeartIcon, HeartIcon, SparklesIcon, BoxIcon } from "lucide-react";
import { benefits, images } from "../data/content";
const icons: Record<(typeof benefits)[number]['icon'], BoxIcon> = {
  heart: HeartIcon,
  brain: BrainIcon,
  calendar: CalendarHeartIcon,
  sparkles: SparklesIcon
};
export function Benefits() {
  return <section aria-labelledby="benefits-title" className="bg-paper" data-id="element-1" data-mp="3vqgv4p5cvlhk">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:py-24" data-id="element-2" data-mp="3qsp4dygg65ey">
        <h2 id="benefits-title" className="max-w-2xl font-display text-[2rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-3" data-mp="3mqaj77pb2tki">
          ¿Qué vas a encontrar dentro?
        </h2>
        <div className="mt-4 grid items-center gap-4 sm:mt-12 lg:gap-12 lg:grid-cols-[1fr_1.1fr]" data-id="element-4" data-mp="3hssghz1vtaky">
          <img src={images.spread} alt="Diario abierto en las páginas Progreso del mes y Mi vision board" className="w-full mix-blend-multiply" data-id="element-5" data-mp="3cu7epv6zeiue" />
          <ol className="space-y-6 sm:space-y-8" data-id="element-6" data-mp="1b1jc9o25vzfo">
            {benefits.map(b => {
            const Icon = icons[b.icon];
            return <li key={b.title} className="flex gap-4 sm:gap-5" data-id="element-7" data-mp="2pwmk14781q9">
                  <span className="flex h-10 w-10 shrink-0 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-ink text-rust" data-id="element-8" data-mp="6tuglxeo2mcg">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-9" data-mp="3p0iotw50jpmc" />
                  </span>
                  <div data-id="element-10" data-mp="3txr6lvm91rn2">
                    <h3 className="font-display text-lg font-extrabold leading-snug sm:text-xl" data-id="element-11" data-mp="lhpc1lk274t8">{b.title}</h3>
                    <p className="mt-1.5 leading-relaxed text-ink-soft" data-id="element-12" data-mp="qgit1nyk1dy5">{b.text}</p>
                  </div>
                </li>;
          })}
          </ol>
        </div>
      </div>
    </section>;
}